export const rules = {
    user_id: [
        { required: true, message: 'Пожалуйста, введите пользователь ', trigger: 'blur' },
    ],
};
